<div class='popup'>

	<div class='category movers'>
		<div class='title' i18n>Suppliers of moving services</div>
		<ul class='movers-list'>
			<li *ngFor='let mover of movers;'>{{mover.cu_company_name_business}}</li>
		</ul>
		<!-- No movers based on response -->
		<div *ngIf='movers.length === 0' class='no-movers' i18n>Based on your origin and destination we don't have any partners that can provide quotes to you.</div>
	</div>

	<div *ngIf='serviceProviders.length > 0' class='category third-party'>
		<div class='title' i18n>Third parties (in case you requested additional services)</div>
		<ul class='third-party-list'>
			<li *ngFor='let provider of serviceProviders;'>{{provider.cu_company_name_business}}</li>
		</ul>
	</div>

</div>